import { useWSModal } from "@wingspanhq/fe-component-library";
import { W8BENCertify } from "./index";

export const useModalFormW8BENCertification = () =>
  useWSModal(W8BENCertify, {
    title: "Certify your W-8 is accurate",
    size: "S"
  });
